import * as TYPES from '../types'
import api from '../../api'

const state = {
  selector: {
    headers: [],
    items: []
  },
  all: [],
  hot: []
}

const mutations = {
  [TYPES.ON_GET_ALL_BRANDS](state, data) {
    state.all = data
  },
  [TYPES.ON_GET_BRANDS_SELECTOR_HEADERS](state, data) {
    state.selector.headers = data
  },
  [TYPES.ON_GET_BRANDS_BY_SEARCH_SELECTOR_HEADER](state, data) {
    state.selector.items = data
  }
}

const actions = {
  [TYPES.ORDER_BRANDS]({commit}, items) {
    return new Promise((resolve, reject) => {
      api.ORDER_BRANDS(items)
      .then(res => {
        resolve(res)
      })
      .catch(res => {
        reject(res)
      })
    })
  },
  [TYPES.DO_GET_ALL_BRANDS]({ commit }) {
    return new Promise(function (resolve, reject) {
      api
        .DO_GET_ALL_BRANDS()
        .then(res => {
          if (res.data.ok) {
            commit(TYPES.ON_GET_ALL_BRANDS, res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.DO_GET_BRANDS_SELECTOR_HEADERS]({ commit }) {
    return new Promise(function (resolve, reject) {
      api
        .DO_GET_BRANDS_SELECTOR_HEADERS()
        .then(res => {
          if (res.data.ok) {
            commit(TYPES.ON_GET_BRANDS_SELECTOR_HEADERS, res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.DO_GET_BRANDS_BY_SEARCH_SELECTOR_HEADER]({ commit }, header) {
    return new Promise(function (resolve, reject) {
      api
        .DO_GET_BRANDS_SEARCH_BY_SELECTOR_HEADER(header)
        .then(res => {
          if (res.data.ok) {
            commit(TYPES.ON_GET_BRANDS_BY_SEARCH_SELECTOR_HEADER, res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.DO_ADD_BRAND]({commit}, brand) {
    return new Promise((resolve, reject) => {
      api.DO_ADD_BRAND(brand)
      .then(res => {
        if (res.data.ok) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(res => {
        reject(res)
      })
    })
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/brands.js